import classNames from 'classnames';
import { useFormikContext } from 'formik';
import { ForwardedRef, forwardRef, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '../../atoms/Button';
import './style.scss';

type NavigationProps = {
  nextStepLabel: ReactNode;
  isLoading: string;
  step: 'shipping' | 'payment';
  onPreviousStepClick?: () => void;
  disabledInformation?: string | undefined;
  customButton?: ReactNode;
};

const Navigation = forwardRef(
  (
    { nextStepLabel, onPreviousStepClick, isLoading, disabledInformation, customButton, step }: NavigationProps,
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    const { submitForm } = useFormikContext();
    const isDisabled = !!disabledInformation;

    return (
      <>
        <div className="navigation-section" ref={ref}>
          <div>
            {onPreviousStepClick && (
              <div
                className={classNames('navigation-section__previous-step', { 'cursor-disabled': !!isLoading })}
                onClick={!isLoading ? onPreviousStepClick : () => {}}
                data-test-id="navigation-previous-step"
              >
                <FormattedMessage id="generic.previousStep" />
              </div>
            )}
          </div>
          {isDisabled || !customButton ?
            <Button
              type="button"
              onClick={() => !isLoading && submitForm()}
              className={classNames('navigation-section__next-step', { 'cursor-disabled': isLoading })}
              disabled={isDisabled}
              data-test-id="navigation-next-step"
              isLoading={isLoading === `submitting:${step}`}
            >
              {nextStepLabel}
            </Button>
          : customButton}
        </div>
        {isDisabled && (
          <p className="navigation-section__error-message" data-test-id="navigation-section-error-message">
            <FormattedMessage id={disabledInformation} />
          </p>
        )}
      </>
    );
  }
);

export default Navigation;
